import { render, staticRenderFns } from "./ListUserExamination.vue?vue&type=template&id=40d82a98&"
import script from "./ListUserExamination.vue?vue&type=script&lang=js&"
export * from "./ListUserExamination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports